import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../service/table.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../basic-features/icon-v2/icon.component";
import * as i4 from "../../../../basic-features/checkbox-v2/checkbox.component";
import * as i5 from "../../../../basic-features/button-v2/button.component";
import * as i6 from "@ngx-translate/core";
/**
 * @deprecated use v3 version of this component instead
 */
function VisibilitySettingsComponent_div_5_div_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 12)(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "geaui-checkbox-v2", 13);
    i0.ɵɵlistener("changed", function VisibilitySettingsComponent_div_5_div_7_Template_geaui_checkbox_v2_changed_4_listener($event) {
      const column_r4 = i0.ɵɵrestoreView(_r3).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.selectionChanged(column_r4, $event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const column_r4 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, column_r4.displayName));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("initialValue", column_r4.visible);
  }
}
function VisibilitySettingsComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("click", function VisibilitySettingsComponent_div_5_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      return i0.ɵɵresetView($event.stopPropagation());
    });
    i0.ɵɵelementStart(1, "div", 5)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "geaui-icon-v2", 6);
    i0.ɵɵlistener("click", function VisibilitySettingsComponent_div_5_Template_geaui_icon_v2_click_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      $event.stopPropagation();
      return i0.ɵɵresetView(ctx_r1.open = false);
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(6, "div", 7);
    i0.ɵɵtemplate(7, VisibilitySettingsComponent_div_5_div_7_Template, 5, 4, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 9)(9, "geaui-button-v2", 10);
    i0.ɵɵlistener("click", function VisibilitySettingsComponent_div_5_Template_geaui_button_v2_click_9_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.selectAll());
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "geaui-button-v2", 11);
    i0.ɵɵlistener("click", function VisibilitySettingsComponent_div_5_Template_geaui_button_v2_click_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.confirmSelection());
    });
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(4, 7, "UI-LIB.TABLE.TABLE-SETTINGS"), " (", ctx_r1.selectedItems, ")");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("clickable", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.columns);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("type", "tertiary");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 9, "UI-LIB.GENERAL.SELECT-ALL"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(14, 11, "X.BUTTON.SELECT"));
  }
}
export class VisibilitySettingsComponent {
  tableService;
  columns;
  tableId = '';
  open = false;
  selectedItems = 0;
  subscription;
  constructor(tableService) {
    this.tableService = tableService;
  }
  ngOnInit() {
    this.subscription = this.tableService.getOrInitializeColumnTableSettings(this.tableId).subscribe(settings => this.applyVisibilitySettings(settings));
  }
  selectionChanged(column, value) {
    column.visible = value;
    this.selectedItems = this.columns?.filter(column => column.visible === true).length || 0;
  }
  selectAll() {
    const settings = {};
    this.columns?.forEach(column => {
      settings[column.key] = {
        visible: true
      };
    });
    this.tableService.updateColumnTableSettings(this.tableId, {
      columns: settings
    });
    this.open = false;
  }
  confirmSelection() {
    const settings = {};
    this.columns?.forEach(column => {
      settings[column.key] = {
        visible: column.visible
      };
    });
    this.tableService.updateColumnTableSettings(this.tableId, {
      columns: settings
    });
    this.open = false;
  }
  applyVisibilitySettings(settings) {
    this.columns?.forEach(column => {
      if (settings?.columns[column.key]?.visible !== undefined) {
        column.visible = settings.columns[column.key].visible;
      } else {
        column.visible = true;
      }
    });
    this.selectedItems = this.columns?.filter(column => column.visible === true).length || 0;
  }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
  static ɵfac = function VisibilitySettingsComponent_Factory(t) {
    return new (t || VisibilitySettingsComponent)(i0.ɵɵdirectiveInject(i1.TableServiceV2));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: VisibilitySettingsComponent,
    selectors: [["geaui-visibility-settings"]],
    inputs: {
      columns: "columns",
      tableId: "tableId"
    },
    decls: 6,
    vars: 5,
    consts: [[1, "visibility-settings-container"], [1, "settings-toggle", 3, "click"], ["file", "16px_settings-gear", "color", "black", 1, "settings-icon", 3, "clickable"], ["class", "filter-container", 3, "click", 4, "ngIf"], [1, "filter-container", 3, "click"], [1, "filter-header"], ["file", "16px_close", 3, "click", "clickable"], [1, "options-container"], ["class", "option", 4, "ngFor", "ngForOf"], [1, "footer"], [1, "select-all-button", 3, "click", "type"], [3, "click"], [1, "option"], [3, "changed", "initialValue"]],
    template: function VisibilitySettingsComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "span", 1);
        i0.ɵɵlistener("click", function VisibilitySettingsComponent_Template_span_click_1_listener() {
          return ctx.open = !ctx.open;
        });
        i0.ɵɵelement(2, "geaui-icon-v2", 2);
        i0.ɵɵtext(3);
        i0.ɵɵpipe(4, "translate");
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(5, VisibilitySettingsComponent_div_5_Template, 15, 13, "div", 3);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("clickable", true);
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "UI-LIB.TABLE.TABLE-SETTINGS"));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.open);
      }
    },
    dependencies: [i2.NgForOf, i2.NgIf, i3.IconComponent, i4.CheckboxV2Component, i5.ButtonV2Component, i6.TranslatePipe],
    styles: [".settings-toggle[_ngcontent-%COMP%]{cursor:pointer;display:flex;align-items:center}.visibility-settings-container[_ngcontent-%COMP%]{position:relative}.filter-container[_ngcontent-%COMP%]{position:absolute;border:2px solid var(--geaui-primary);background-color:var(--geaui-pure-white);z-index:3;right:0}.filter-container[_ngcontent-%COMP%]   .filter-header[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding:10px}.filter-container[_ngcontent-%COMP%]   .filter-header[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-weight:500;font-size:16px;color:var(--geaui-primary-black)}.filter-container[_ngcontent-%COMP%]   .options-container[_ngcontent-%COMP%]{background-color:var(--geaui-grey-05);overflow-y:scroll;max-height:176px}.filter-container[_ngcontent-%COMP%]   .options-container[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]{display:flex;justify-content:space-between;align-items:center;padding:10px}.filter-container[_ngcontent-%COMP%]   .options-container[_ngcontent-%COMP%]   .option[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{margin-right:50px;font-weight:400;font-size:16px;color:var(--geaui-primary-black)}.filter-container[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]{padding:10px;display:flex;justify-content:space-between}.filter-container[_ngcontent-%COMP%]   .footer[_ngcontent-%COMP%]   .select-all-button[_ngcontent-%COMP%]{margin-right:10px}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VisibilitySettingsComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-visibility-settings',
      template: "<div class=\"visibility-settings-container\">\n  <span class=\"settings-toggle\" (click)=\"open = !open\"\n    ><geaui-icon-v2 class=\"settings-icon\" [clickable]=\"true\" file=\"16px_settings-gear\" color=\"black\"></geaui-icon-v2\n    >{{ 'UI-LIB.TABLE.TABLE-SETTINGS' | translate }}</span\n  >\n  <div class=\"filter-container\" *ngIf=\"open\" (click)=\"$event.stopPropagation()\">\n    <div class=\"filter-header\">\n      <span>{{ 'UI-LIB.TABLE.TABLE-SETTINGS' | translate }} ({{ selectedItems }})</span>\n      <geaui-icon-v2 [clickable]=\"true\" (click)=\"$event.stopPropagation(); open = false\" file=\"16px_close\"></geaui-icon-v2>\n    </div>\n    <div class=\"options-container\">\n      <div class=\"option\" *ngFor=\"let column of columns\">\n        <span>{{ column.displayName | translate }}</span\n        ><geaui-checkbox-v2 [initialValue]=\"column.visible\" (changed)=\"selectionChanged(column, $event)\"></geaui-checkbox-v2>\n      </div>\n    </div>\n    <div class=\"footer\">\n      <geaui-button-v2 class=\"select-all-button\" [type]=\"'tertiary'\" (click)=\"selectAll()\">{{\n        'UI-LIB.GENERAL.SELECT-ALL' | translate\n      }}</geaui-button-v2\n      ><geaui-button-v2 (click)=\"confirmSelection()\">{{ 'X.BUTTON.SELECT' | translate }}</geaui-button-v2>\n    </div>\n  </div>\n</div>\n",
      styles: [".settings-toggle{cursor:pointer;display:flex;align-items:center}.visibility-settings-container{position:relative}.filter-container{position:absolute;border:2px solid var(--geaui-primary);background-color:var(--geaui-pure-white);z-index:3;right:0}.filter-container .filter-header{display:flex;justify-content:space-between;align-items:center;padding:10px}.filter-container .filter-header span{font-weight:500;font-size:16px;color:var(--geaui-primary-black)}.filter-container .options-container{background-color:var(--geaui-grey-05);overflow-y:scroll;max-height:176px}.filter-container .options-container .option{display:flex;justify-content:space-between;align-items:center;padding:10px}.filter-container .options-container .option span{margin-right:50px;font-weight:400;font-size:16px;color:var(--geaui-primary-black)}.filter-container .footer{padding:10px;display:flex;justify-content:space-between}.filter-container .footer .select-all-button{margin-right:10px}\n"]
    }]
  }], () => [{
    type: i1.TableServiceV2
  }], {
    columns: [{
      type: Input
    }],
    tableId: [{
      type: Input
    }]
  });
})();
